import { gql } from '@apollo/client';

export const ADD_UPDATE_LEASING_INTEREST_TYPE_DETAIL = gql`
  mutation addOrUpdateLeasingInterestTypeDetail($input: LeasingInterestTypeDetailInput!) {
    addOrUpdateLeasingInterestTypeDetail(input: $input) {
      commandId
      correlationId
    }
  }
`;
